export default "__VITE_ASSET__BPbNeibI__"